import React, { useState } from 'react';
import { FolderOpenOutlined, FolderOutlined } from "@ant-design/icons";

const FolderTree = () => {

    const [data, setData] = useState([
        {
            open: false,
            hasChild: true,
            title: '2.2.1_PrimaryClause', blocks: [
                { title: '10', style: { backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                { title: '10', style: { backgroundColor: 'green', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                { title: '10', style: { backgroundColor: 'yellow', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                { title: '10', style: { backgroundColor: 'blue', borderRadius: 5, color: 'white', padding: '5px 10px' } }
            ],
            children: [
                {
                    hasChild: true,
                    open: false,
                    title: '2.2.1_PrimaryClause Child 1', blocks: [
                        { title: '10', style: { backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'green', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'yellow', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'blue', borderRadius: 5, color: 'white', padding: '5px 10px' } }
                    ],
                    children: [
                        {
                            title: '2.2.1_PrimaryClause Child 1 1', blocks: [
                                { title: '10', style: { backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'green', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'yellow', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'blue', borderRadius: 5, color: 'white', padding: '5px 10px' } }
                            ]
                        },
                        {
                            title: '2.2.1_PrimaryClause Child 1 2', blocks: [
                                { title: '10', style: { backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'green', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'yellow', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'blue', borderRadius: 5, color: 'white', padding: '5px 10px' } }
                            ]
                        },
                        {
                            title: '2.2.1_PrimaryClause Child 1 3', blocks: [
                                { title: '10', style: { backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'green', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'yellow', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                                { title: '10', style: { backgroundColor: 'blue', borderRadius: 5, color: 'white', padding: '5px 10px' } }
                            ]
                        },
                    ]
                },
                {
                    hasChild: false,
                    title: '2.2.1_PrimaryClause Child 2', blocks: [
                        { title: '10', style: { backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'green', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'yellow', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'blue', borderRadius: 5, color: 'white', padding: '5px 10px' } }
                    ]
                },
                {
                    hasChild: false,
                    title: '2.2.1_PrimaryClause Child 3', blocks: [
                        { title: '10', style: { backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'green', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'yellow', borderRadius: 5, color: 'white', padding: '5px 10px' } },
                        { title: '10', style: { backgroundColor: 'blue', borderRadius: 5, color: 'white', padding: '5px 10px' } }
                    ]
                },
            ]
        }
    ]);

    // const toggleFolder = (index) => {
    //     console.log(index);
    // }

    const FolderStructure = ({ item, margin = 0 }) => {
        const [folderItem, setFolderItem] = useState(item);

        const toggleFolder = () => {
            if (!folderItem.hasChild) return;
            setFolderItem({ ...folderItem, open: !folderItem.open })
        }
        return (
            <>
                <div className='folder-tree' onClick={() => toggleFolder()}>
                    <p className='folder-tree-text'>{folderItem.title}</p>
                    {
                        folderItem.open ?
                            <FolderOpenOutlined style={{ color: 'white', fontSize: 25, marginRight: 10 }} /> :
                            <FolderOutlined style={{ color: 'white', fontSize: 25, marginRight: 10 }} />
                    }
                    <div className='folder-tree-text-box'>
                        <p style={{ backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' }}>10</p>
                        <p style={{ backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' }}>10</p>
                        <p style={{ backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' }}>10</p>
                        <p style={{ backgroundColor: 'red', borderRadius: 5, color: 'white', padding: '5px 10px' }}>10</p>
                    </div>
                </div>
                {
                    (folderItem.hasChild && folderItem.open) && (
                        item.children.map((x, childIndex) => (
                            <div style={{ marginLeft: margin + 20 }}>
                                <FolderStructure item={x} index={childIndex} margin={margin + 20} />
                            </div>
                        ))
                    )
                }
            </>
        )
    }

    return (
        <div>
            {
                data.map((x, i) => (
                    <FolderStructure item={x} index={i} />
                ))
            }
        </div>

    )
};

export default FolderTree;